import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { Lightbox } from 'ngx-lightbox';
import { SharedService } from "../../services/shared.service";
import $ from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';
import { S3Service } from 'src/app/services/s3.service';
import { AsYouType, parsePhoneNumber } from 'libphonenumber-js';
import * as _ from 'lodash';
import { Constants } from '../../Constants';
import { FormPreviewService } from '../../form-preview/form-preview.service';
import { PdfViewerModalComponent } from "../../pdf-viewer-modal/pdf-viewer-modal.component";
import { PasswordModalComponent }  from '../../password-modal/password-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from "../../../environments/environment";
import * as moment from 'moment-timezone';
@Component({
  selector: 'app-template-preview',
  templateUrl: './template-preview.component.html',
  styleUrls: ['./template-preview.component.scss']
})
export class TemplatePreviewComponent implements OnInit {
  template: any = []
  subTopicsData = []
  formName = ""
	successMsg = false;
	editable: Boolean = true;
	phoneNumber = "";
	templateVersion: String = "";
  templateId;
	updatedAt;
	organization;
	organizationId = localStorage.getItem('organization');
	formResponse: any = {};
	isActive = "";
	saveValidity: Boolean = true;
	logoSource = "../../assets/images/sort-logo.svg";
	organizationLogo = "../../assets/images/default_organisation.png";
	isHelpForm = false;
  isTemplateChanged = false;
  showTemplatePreview = false;
  tempTemplate:any = []
  
  @ViewChild("teamDropdown") teamDropdown: MatSelect;

// formName = "Hello form"

  constructor(
    private _sharedService: SharedService,
    private _changeDetectionRef: ChangeDetectorRef,
    private _lightbox: Lightbox,
    private _domSanitizer: DomSanitizer,
		private _s3Service: S3Service,
    private _formPreviewService: FormPreviewService,
    public dialog: MatDialog,
    private _router: Router,
    private _location: Location,
  ) { 
    this._sharedService.templateChange.subscribe((obj) => {
		this.tempTemplate = _.cloneDeep(obj.schema)
		this.template = obj.schema
		this.formName = obj.formName
		this.templateVersion = obj.template_version
		this.isTemplateChanged = obj.isTemplateChanged
		this.templateId = obj.templateId
		this.successMsg = false
		this.subTopicsData = []
		this.formResponse = {}
		this.tempTemplate.forEach((element) => {
			element.error = "";
			if(element['value']) {
				delete element.value
			}
			if(element.type && element.type == "address")  {
				element.data = {}
			}
		});
		this.template = _.cloneDeep(this.tempTemplate)
		// this._changeDetectionRef.detectChanges()
    })
  }

  ngOnInit(): void {
	
		moment.tz.setDefault(environment.data_time_timezone)
	
  }

  onInsurance(event, element) {
		
		if (event.target.files && event.target.files[0] && element["type"] === 'picture') {
			if(!Constants.acceptedImageTypes.includes(event.target.files[0].type)) {
				element.error = "Invalid image format. Please upload only JPEG, PNG, WEBP images.";
				return;
			}
			if (!element['value']) element['value'] = [];	
			if (!element['picture_files']) element['picture_files'] = [];
			var filesAmount = event.target.files.length;
			let filesLength = element['picture_files'].length + filesAmount;
			if (filesLength > 5 || filesAmount > 5) {
				let templateIndex = this.template.findIndex((field) => field.key === element.key);
				this.template[templateIndex].error = "Only five picture uploads are allowed per field";
				return;
			}
			for (let i = 0; i < filesAmount; i++) {
				if (event.target.files[i]["size"] > 5000000) {
					let templateIndex = this.template.findIndex((field) => field.key === element.key);
					this.template[templateIndex].error = "Image size cannot exceed 5MB";
					return;
				}
			}

			for (let i = 0; i < filesAmount; i++) {
				var reader = new FileReader();
				reader.onload = (event: any) => {
					if (element.type === 'picture') {
						let image = event.target.result;
						element['value'].push({ src: image, thumb: image});
					}
				}
				reader.readAsDataURL(event.target.files[i]);
				element['picture_files'].push(event.target.files[i]);
			}
		}
		if (event.target.files && event.target.files[0] && element["type"] === 'file') {
			if(!Constants.acceptedFileTypes.includes(event.target.files[0].type)) {
				element.error = "Invalid file type. Only PDF is allowed.";
				return;
			}
			if (!element['value']) element['value'] = [];
			if (!element['picture_files']) element['picture_files'] = [];
			if (!element['raw_images']) element['raw_images'] = [];
			var filesAmount = event.target.files.length;
			let filesLength = element['picture_files'].length + filesAmount;
			if (filesLength > 5 || filesAmount > 5) {
				let templateIndex = this.template.findIndex((field) => field.key === element.key);
				this.template[templateIndex].error = "Only five file uploads are allowed per field";
				return;
			}

			for (let i = 0; i < filesAmount; i++) {
				if (event.target.files[i]["size"] > 5000000) {
					let templateIndex = this.template.findIndex((field) => field.key === element.key);
					this.template[templateIndex].error = "File size cannot exceed 5MB";
					return;
				}
			}

			for (let i = 0; i < filesAmount; i++) {
				var reader = new FileReader();
				reader.onload = (event: any) => {
					let image = event.target.result.split(',')[1];
					element['raw_images'].push(this._domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([new Uint8Array(atob(image).split('').map(char => char.charCodeAt(0)))], { type: 'application/pdf'}))));
				}
				reader.readAsDataURL(event.target.files[i]);
				element['picture_files'].push(event.target.files[i]);
			}
		}
		let templateIndex = this.template.findIndex((field) => field.key === element.key);
		this.template[templateIndex]["error"] = "";
		const input = document.getElementById(element.key);
		input["value"] = null;
	}

	deletePicture(element, index) {
		element['value'].splice(index, 1);
		element['picture_files'].splice(index, 1);
		// this.template[index]["error"] = "";
		element["error"] = "";
	}

	open(index: number, images): void {
		// open lightbox
		this._lightbox.open(images, index);
	}

	close(): void {
		// close lightbox programmatically
		this._lightbox.close();
	}

	deleteFile(element, index) {
		element['value'].splice(index, 1);
		element['picture_files'].splice(index, 1);
		// this.template[index]["error"] = "";
		element["error"] = "";
	}

	onCancel() {
		// <HTMLFormElement>document.getElementById("form-submission").reset()
		// this.submissionForm.reset()
		this.subTopicsData = []
		this.formResponse = {}
		this.subTopicsData = []
    	this.resetValuesSavedInTemplate()
	}

	getHostName() {
		return document.location.protocol + '//' + document.location.hostname + '/';
	}

	getSubTopics() {
		const subTopicsFieldData = this.template.find(c => c.key === 'subtopic');
		return subTopicsFieldData.dependent_data[this.formResponse['topic']];
	}

	getValue(element) {
		if (this.formResponse && this.formResponse[element.key] && element.key !== 'topic') {
			const selectedItem = element.data.find(c => c.label === element.value);
			return selectedItem;
		} else if (element.key === 'topic') {
			const selectedItem = element.data.find(c => c.label === this.formResponse['topic']);
			if (selectedItem) return selectedItem;
		} else if (element.key === 'subtopic') {
			return this.subTopicsData;
		}
		return element.data[1];
	}

	onFieldChange(key, value, type) {

		if (type === 'question' || type === 'checkbox') {
			if (value === 'true') value = true;
			if (value === 'false') value = false;
		}
		if (type === 'select') {
			var selectData = {};
			selectData[value.value] = value.label;
			value = selectData;
		}
		if (type === "contact") {
			let index = this.template.findIndex((element) => element.key === key);
			let obj = {
				email: "",
				phone: "",
				checked : false
			}
			this.formResponse[key] = obj;
			if (value === "yes") {
				this.template[index]["data"]["checked"] = true;
			} else {
				this.template[index]["data"]["checked"] = false;
				this.template[index]["data"]["email"] = "";
				this.template[index]["data"]["phone"] = "";
				this.formResponse[key]["email"] = "";
				this.formResponse[key]["phone"] = "";
			}
			value = {
				requested: this.template[index]["data"]["checked"],
				email: "",
				phone: ""
			}
		}

		if(type == "address") {
			let index = this.template.findIndex((element) => element.key === key);
			let obj = {
				address: "",
				city: "",
				state: "",
				zipcode: "",
				checked: false
			}
			this.formResponse[key] = obj;
			if(value == "yes") {
				this.template[index]["data"]["checked"] = true;
			} else {
				this.template[index]["data"]["checked"] = false;
				this.template[index]["data"]["address"] = "";
				this.template[index]["data"]["city"] = "";
				this.template[index]["data"]["state"] = "";
				this.template[index]["data"]["zipcode"] = "";
			}
			value = {
				requested: this.template[index]["data"]["checked"],
				address: "",
				city: "",
				state: "",
				zipcode: "",
			}
		}

		this.formResponse[key] = value;
		let templateIndex = this.template.findIndex((element) => element.key === key);
		this.template[templateIndex]["error"] = "";

		if (key === 'topic') {
			const subTopicsFieldData = this.template.find(c => c.key === 'subtopic');
			const topicId = String((Object.keys(this.formResponse['topic']))[0]);
			this.subTopicsData = [];
			this.subTopicsData = subTopicsFieldData.dependent_data[topicId];
			let subtopicIndex = this.template.findIndex((element) => element.key === "subtopic");
			this.template[subtopicIndex]["error"] = "";
			if (this.formResponse["subtopic"]) {
				delete this.formResponse["subtopic"]; // Deleting subtopic selection
			}
			this.teamDropdown.value = null;
		}
	}

	onPhoneInputChange(value, key) {
		$('.numbersOnly').keyup(function () { 
			this.value = this.value.replace(/[^0-9()\-. ]/g,'');
		});
		this.formResponse[key] = new AsYouType('US').input(value);
		let templateIndex = this.template.findIndex((element) => element.key === key);
		this.template[templateIndex]["error"] = "";
		this.template[templateIndex]["value"] = this.formResponse[key];
	}

	onContactInputChange(key, type, value) {
		if (type === 'email') {
			this.formResponse[key]["email"] = value;
		} else {
			this.formResponse[key]["phone"] = new AsYouType('US').input(value);
			let templateIndex = this.template.findIndex((field) => field.key === key);
  		this.template[templateIndex]["error"] = "";
			this.template[templateIndex]["data"]["phone"] = this.formResponse[key]["phone"];
		}
		$('.numbersOnly').keyup(function () {
			this.value = this.value.replace(/[^0-9()\-. ]/g,'');
		});
	}

	onContactInputBlur(key, type) {
		if (type === 'email') {
			let email = this.formResponse[key]["email"];
			const re = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
			let valid = re.test(String(email).toLowerCase());
			if (!valid) {
				let index = this.template.findIndex((element) => element.key === key);
				this.template[index]["data"]["emailError"] = "Enter valid email address";
				// this.saveValidity = false;
			} else {
				let index = this.template.findIndex((element) => element.key === key);
				this.template[index]["data"]["emailError"] = "";
				// this.saveValidity = true;
			}
		} else {
			let index = this.template.findIndex((element) => element.key === key);
			try {
				let phone = parsePhoneNumber(this.formResponse[key]["phone"], "US");
				const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
				let nationalNumber = phone.formatNational();
				let valid = re.test(nationalNumber);
				if (!valid) {
					this.template[index]["data"]["phoneError"] = "Enter valid phone number";
					// this.saveValidity = false;
				} else {
					this.formResponse[key]["phone"] = phone.number;
					this.template[index]["data"]["phoneError"] = "";
					// this.saveValidity = true;
				}
			} catch (error) {
				this.template[index]["data"]["phoneError"] = "Enter valid phone number";
			}
			
		}
	}

	onSave() {
		if (this.saveValidity) {
			let validity = true;
			var formData: FormData = new FormData();
			let topicsExist = true;
			let attachements = {}
			this.template.forEach(element => {
				if (element.value && element.picture_files) {
					if (!this.formResponse[element.key]) this.formResponse[element.key] = [];
					attachements[element.key]= []
					_.forEach(element.picture_files, (image, index) => {
						const file: File = image;
						const fileName = element.key + '_' + index;
						if (!_.includes(attachements[element.key], fileName)) {
							// this.formResponse[element.key].push(fileName);
							formData.append(fileName, file);
							attachements[element.key].push(fileName)
						}
					});
				}
				if (element.key === 'employeename') {
					if (!this.formResponse[element.key] || this.formResponse[element.key].length  === 0) {
						this.openResubmitToast();
						element.error = "This is a mandatory field";
						validity = false;
						return false;
					}
				} else if (element.key === "topic") {
					if (element.data.length === 0) {
						topicsExist = false;
						return false;
					}
					if (!this.formResponse[element.key] || this.formResponse[element.key].length  === 0) {
						this.openResubmitToast();
						element.error = "This is a mandatory field";
						validity = false;
						return false;
					}
				} else if (element.key === "subtopic") {
					if (topicsExist) {
						let topic = "";
						if (!this.formResponse["topic"]) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
						if (this.formResponse["topic"] && Object.keys(this.formResponse["topic"])[0]) {
							topic= Object.keys(this.formResponse["topic"])[0];
						}
						if (element.dependent_data) {
							let subtopics = element.dependent_data[topic];
							if (subtopics.length > 0) {
								if (!this.formResponse[element.key] || this.formResponse[element.key].length  === 0) {
									this.openResubmitToast();
									element.error = "This is a mandatory field";
									validity = false;
									return false;
								}
							}
						}
					}
				} else if (element.key === "subject") {
					if(element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length  === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "text" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					// if (this.formResponse[element.key] && this.formResponse[element.key].length < element.validate.minlength) {
					// 	element.error = "This field should contain more than 1 character";
					// 	validity = false;
					// 	return false;
					// }
					if (this.formResponse[element.key] && this.formResponse[element.key].length > element.validate.maxlength) {
						this.openResubmitToast();
						element.error = element.validate && element.validate.maxlength ? "This field should not contain more than "+ element.validate.maxlength +" characters" : "This field should not contain more than 50 characters";
						validity = false;
						return false;
					}
				} else if (element.type === "textarea" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key] && this.formResponse[element.key].length > element.validate.maxlength) {
						this.openResubmitToast();
						element.error = "This field should not contain more than 350 characters";
						validity = false;
						return false;
					}
				} else if (element.type === "email" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key]) {
						let email = this.formResponse[element.key];
						let regex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
						if (!regex.test(email)) {
							element.error = "Enter valid email address"
							validity = false;
							this.openResubmitToast();
							return false;
						}
					}
				} else if (element.type === "phone" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key]) {
						let phone;
						try {
							phone = parsePhoneNumber(this.formResponse[element.key], "US");
							let nationalNumber = phone.formatNational();
							let regex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
							if (!regex.test(nationalNumber)) {
								element.error = "Enter valid phone number"
								validity = false;
								this.openResubmitToast();
								return false;
							} else {
								let phone = parsePhoneNumber(this.formResponse[element.key], "US");
								this.formResponse[element.key] = phone.number;
							}
						} catch (error) {
							element.error = "Enter valid phone number"
							this.openResubmitToast();
							validity = false;
							return false;
						}
					}
				} else if (element.type === "radio" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key]) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "checkbox" && element.visible) {

					if (!(element.key in this.formResponse)) {
						if (element.defaultValue) {
							this.formResponse[element.key] = element.defaultValue;
						}
					}

					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "select" && element.key !== "subtopic" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "picture" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "file" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "question" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "contact" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (element.key in this.formResponse) {
						if (this.formResponse[element.key].requested) {
							if (this.formResponse[element.key].email.length === 0) {
								let templateIndex = this.template.findIndex((field) => field.key === element.key);
								this.template[templateIndex]["data"]["emailError"] = "Enter valid email address";
								validity = false;
								this.openResubmitToast();
								// return false;
							} else {
								let templateIndex = this.template.findIndex((field) => field.key === element.key);
								let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
								let valid = emailRegex.test(String(this.formResponse[element.key].email).toLowerCase());
								if(!valid) {
									this.template[templateIndex]["data"]["emailError"] = "Enter valid email address";
									validity = false;
									this.openResubmitToast();
									// return false;
								}
							}
							if (this.formResponse[element.key].phone.length === 0) {
								let templateIndex = this.template.findIndex((field) => field.key === element.key);
								this.template[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
								validity = false;
								this.openResubmitToast();
								// return false;
							} else {
								let templateIndex = this.template.findIndex((field) => field.key === element.key);
								try {
									let phone = parsePhoneNumber(this.formResponse[element.key].phone, "US");
									const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
									let nationalNumber = phone.formatNational();
									let valid = re.test(nationalNumber);
									if(!valid) {
										this.template[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
										validity = false;
										this.openResubmitToast();
										// return false;
									}
								} catch (error) {
									this.template[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
									validity = false;
									this.openResubmitToast();
								}
								
							}
						}
					}
				} else if(element.type == "address" && element.visible) {
					// if (element.validate.required) {
					// 	if (!(element.key in this.formResponse)) {
					// 		this.openResubmitToast();
					// 		element.error = "This is a mandatory field";
					// 		validity = false;
					// 		return false;
					// 	}
					// }
					let templateIndex = this.template.findIndex((field) => field.key === element.key);
					if(element.validate.required) {
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['address'] || this.formResponse[element.key]['address'].length == 0) {
							this.template[templateIndex]["data"]['addressError'] = "Enter valid Street Address";
							validity = false;
							this.openResubmitToast();
							// return false;
						} 
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['city'] || this.formResponse[element.key]['city'].length == 0) {
							this.template[templateIndex]["data"]['cityError'] = "Enter valid City name"
							validity = false;
							this.openResubmitToast();
							// return false;
						} 
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['state'] || this.formResponse[element.key]['state'].length == 0) {
							this.template[templateIndex]["data"]['stateError'] = "Enter valid State name"
							validity = false;
							this.openResubmitToast();
							// return false;
						} 
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['zipcode'] || this.formResponse[element.key]['zipcode'].length == 0) {
							this.template[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
							validity = false;
							this.openResubmitToast();
							// return false;
						}
					} 
					if(element.key in this.formResponse) {
						if(this.formResponse[element.key]['zipcode'] && this.formResponse[element.key]['zipcode'].length == 0) {
							this.template[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
							validity = false;
							this.openResubmitToast();
							// return false;
						} else if(this.formResponse[element.key]['zipcode']) {
							let zipCodeValidator = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
							if(!zipCodeValidator.test(this.formResponse[element.key]['zipcode'])) {
								this.template[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
								validity = false;
								this.openResubmitToast();
							}
						}
					}
				} else if (element.type === "date" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "time" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				}
			});


			if (validity) {
				if(attachements && Object.keys(attachements).length > 0) {
					Object.keys(attachements).forEach(key => {
						this.formResponse[key] = attachements[key]
					})
				}
        this.resetValuesSavedInTemplate()
				var formResponseData = {
					response: this.formResponse,
					name: this.formName,
					organization: localStorage.getItem('organization'),
					updated_at: Date.now(),
					topic: this.formResponse['topic'],
					subtopic: this.formResponse['subtopic'],
					submittedBy: this.formResponse['employeename'],
					templateId: this.templateId,
					template_version: this.templateVersion,
					timezone: environment.data_time_timezone,
          templateSchema: {
            schema: this.template
          },
          isTemplateChanged: this.isTemplateChanged
				}
        if(this.isTemplateChanged == true) {
          if(this.templateVersion == "") {
            formResponseData['template_version'] = "v1"
            this.templateVersion = "v1"
          } else {
            formResponseData['template_version'] = this.increaseVersionHistory(this.templateVersion)
            this.templateVersion = this.increaseVersionHistory(this.templateVersion)
          }
        }
				formData.append('formResponse', JSON.stringify(formResponseData));

				this._formPreviewService.submitFormDetails(formData, this.isHelpForm).subscribe(
					(response) => {
						if (response['success']) {
							// if (localStorage.getItem('email')) {
							// 	this._router.navigateByUrl('/dashboard');
							// }
              this._sharedService.changeUpdateButton()
              this.formResponse = {}
							this.successMsg = true;
              setTimeout(() => {
                this.successMsg = false;
              }, 4000)
						}
					},
					err => {
						console.log(err);
						this.successMsg = false;
						if(err.error && err.error.status === 400) {
							this.openResubmitToast(err.error.message);
						}
				});
			}

		}
	}

	openResubmitToast(message?: any) {
		!_.isEmpty(message) ? this._sharedService.openSnackBar(message) :  this._sharedService.openSnackBar(Constants.status.resubmit);
	}

	viewFile(index: number, file, element): void {
		const dialogRef = this.dialog.open(PdfViewerModalComponent, {
			width: '800px',
			data: {
				file: element["raw_images"][index]
			}
		});
	}

	openEnterPasswordDialog(): void {
		this.dialog.open(PasswordModalComponent, {
			data: {
				"type": "enterpassword",
				"templateId": this.templateId
			},
			disableClose: true
		});
	}

	onHoveringLogo() {
		this.logoSource = '../../assets/images/SORT_Logo.gif'
		setTimeout(()=>{
		  this.logoSource = '../../assets/images/sort-logo.svg'
		}, 5000)
	}

	onMouseOutLogo() {
		this.logoSource = '../../assets/images/sort-logo.svg'
	}

	onInputChange(key) {
		let templateIndex = this.template.findIndex((element) => element.key === key);
		this.template[templateIndex]['error'] = "";
	}

  increaseVersionHistory(oldHistory) {
    let presentHistory = parseInt(oldHistory.replace(/^\D+/g, ''))
    return `v${presentHistory + 1}`
  }

  resetValuesSavedInTemplate() {
	  	
	// Kept like this for resetting the form
	this.template = []
	this.template = _.cloneDeep(this.tempTemplate)

	this.tempTemplate.forEach((element) => {
		element.error = "";
		if(element['value']) {
			delete element.value
		}
		if(element.type && element.type == "address")  {
			element.data = {}
		}
	});

	this._changeDetectionRef.detectChanges()
  }

  openPreview() {
	  this._sharedService.changeTemplatePreview(true)
  }

  onAddressInput(key, type, value) {
	let templateIndex = this.template.findIndex((element) => element.key === key);
	if(!this.formResponse[key] || this.formResponse[key] === undefined) {
		this.formResponse[key] = {}
	}
	if(type == "address") {
		this.formResponse[key]["address"] = value;
		this.template[templateIndex]["data"]['addressError'] = ""
	} else if(type == "city") {
		this.formResponse[key]["city"] = value;
		this.template[templateIndex]["data"]['cityError'] = ""
	} else if(type == "state") {
		this.formResponse[key]["state"] = value;
		this.template[templateIndex]["data"]['stateError'] = ""
	} else if(type == "zipcode") {
		this.formResponse[key]["zipcode"] = value;
		this.template[templateIndex]["data"]['zipcodeError'] = ""
	}

	$('.numbersOnly').keyup(function () { 
		this.value = this.value.replace(/[^0-9()\-. ]/g,'');
	});
}

	onAddressBlur(key, type) {
		let templateIndex = this.template.findIndex((element) => element.key === key);
		if(!this.formResponse[key] || this.formResponse[key] === undefined) {
			this.formResponse[key] = {}
		}
		let value = this.formResponse[key][type];
		let zipCodeValidator = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
		if(type == "address" && ((!value || value.length == 0))) {
			this.template[templateIndex]["data"]['addressError'] = "Enter valid Street Address"
		} else if(type == "city" && ((!value || value.length == 0))) {
			this.template[templateIndex]["data"]['cityError'] = "Enter valid City name"
		} else if(type == "state" && ((!value || value.length == 0))) {
			this.template[templateIndex]["data"]['stateError'] = "Enter valid State name"
		} else if(type == "zipcode" && ((!value || value.length == 0) || !zipCodeValidator.test(value))) {
			this.template[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
		}
	}
}
